// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/style.scss
// module id = 586
// module chunks = 376